export default (errorObject) => errorObject.response.data.error
  || errorObject.response.statusText
  || errorObject.response.data.errorCode
  || errorObject.response.status
